import {BsFillExclamationTriangleFill} from "react-icons/bs";
import {useNavigate} from "react-router-dom";
import "./ForbiddenPage.css";
import {strings} from '../../localization/Localization';

const ForbiddenPage = () => {

    let navigate = useNavigate();

    return (
        <div className={"text-center"} id={"forbiddenPage"}>
            <h1 className={"mt-4 mb-5"}>{strings.accessDenied}</h1>
            <BsFillExclamationTriangleFill className={"forbidden-icon"} size={200}/>
            <div className={"my-3"}>{strings.notAllowed}</div>
            <button className={"btn btn-primary w-100"} onClick={() => navigate("/home")}>{strings.goBack}</button>
        </div>)
}

export default ForbiddenPage;

